import React from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"

import { Button } from "components"
import { moveOfflineOrderToCartForEdit } from "utils"
import classes from "./OfflineOrderDetailsCheckoutButton.module.scss"

const OfflineOrderDetailsCheckoutButton = props => {
  const { offlineOrder } = props

  const [t] = useTranslation()

  const history = useHistory()

  const handlePress = () => {
    moveOfflineOrderToCartForEdit(
      offlineOrder
    )

    history.push("/checkout")
  }

  return (
    <div className={classes["container"]}>
      <Button
        fullWidth
        onClick={handlePress}
        color="success"
      >
        {t("پرداخت")}
      </Button>
    </div>
  )
}

export default OfflineOrderDetailsCheckoutButton